import React from 'react';
import { Button, Card, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import MainLayout from '../../layouts/MainLayout';
import { PANEL_PRIMARY_BTN_CLASS } from '../../constants/ui';

const { Title, Text } = Typography;

const ReportPageLayout = ({
  title,
  subtitle,
  headerIcon,
  onExport,
  exportLoading = false,
  children,
}) => {
  return (
    <MainLayout>
      <div className="custom-font max-w-[1400px] mx-auto px-1 sm:px-0 pb-2">
        <Card
          variant="borderless"
          className="shadow-md border border-slate-200/90 dark:border-slate-700 rounded-2xl bg-white dark:bg-slate-900"
        >
          <div className="px-4 pt-5 pb-4 sm:px-6 sm:pt-6 sm:pb-5 border-b border-slate-200/90 dark:border-slate-600">
            <div className="flex flex-wrap items-end justify-between gap-4">
              <div className="flex gap-3 min-w-0 flex-1 items-start">
                {headerIcon ? (
                  <div
                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-slate-200/90 bg-slate-50 text-indigo-600 dark:border-slate-600 dark:bg-slate-800/80 dark:text-indigo-400 sm:h-11 sm:w-11 [&_.anticon]:text-[19px] sm:[&_.anticon]:text-xl"
                    aria-hidden
                  >
                    {headerIcon}
                  </div>
                ) : null}
                <div className="min-w-0 pt-0.5">
                  <Title
                    level={4}
                    className="!mb-1 !mt-0 !font-semibold custom-font text-slate-900 dark:text-slate-100 tracking-tight"
                  >
                    {title}
                  </Title>
                  {subtitle ? (
                    <Text type="secondary" className="text-sm sm:text-[15px] block leading-relaxed">
                      {subtitle}
                    </Text>
                  ) : null}
                </div>
              </div>
              {onExport ? (
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  loading={exportLoading}
                  onClick={onExport}
                  className={`${PANEL_PRIMARY_BTN_CLASS} shrink-0`}
                >
                  خروجی اکسل
                </Button>
              ) : null}
            </div>
          </div>
          <div className="px-4 py-5 sm:px-6 sm:py-6">{children}</div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default ReportPageLayout;
